import React from 'react';
import {
  Alert,
  Button,
  Container,
  Form,
  FormControl,
  Spinner,
} from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { sendForgotPasswordLink } from '../actions/users';
import FormInput from '../components/FormInput';
import StatusAlerts from '../components/StatusAlerts';
import { isMobileMode } from '../utils/mobileBridge';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      loading: false,
      success: false,
      error: false,
    };
  }

  componentDidMount() {
    const email = this.props.match?.params?.email;
    if (email) {
      this.setState({ email: email });
    }
  }

  handleSend = () => {
    this.setState({ loading: true, success: false, error: false }, () => {
      sendForgotPasswordLink(
        this.state.email,
        (response) => {
          this.setState({
            loading: false,
            success: true,
            error: false,
            successMessage: this.props.t('ForgotPassword.emailHasBeenSent'),
          });
        },
        (error) => {
          this.setState({ loading: false, success: false, error: true });
        },
      );
    });
  };

  handleBack = () => {
    this.props.history.goBack();
  };

  render() {
    const { t } = this.props;
    const mobileMode = isMobileMode();
    const containerStyle = mobileMode
      ? {
          width: '100%',
          height: '100vh',
          marginTop: 0,
          borderRadius: 0,
          padding: 20,
        }
      : { maxWidth: 500, marginTop: 100, borderRadius: 5 };

    return (
      <Container style={containerStyle}>
        <div style={{ marginBottom: 10 }}>
          <h1>{t(`ForgotPassword.title`)}</h1>
          {t(`ForgotPassword.info`)}
        </div>
        <FormInput
          id='input_email'
          label={t('ForgotPassword.email')}
          value={this.state.email}
          onChange={(e) => {
            this.setState({ email: e.target.value });
          }}
        />
        <div className='auth-actions'>
          <div>
            <Button
              type='button'
              variant='link'
              onClick={this.handleBack}
              disabled={this.state.loading}>
              {t('auth.back')}
            </Button>
          </div>
          <div>
            <Button
              id='btnLogin'
              variant='primary'
              onClick={() => this.handleSend()}
              disabled={this.state.loading}>
              {t('ForgotPassword.send')}

              {this.state.loading && (
                <Spinner
                  style={{ width: 20, height: 20, marginLeft: 10 }}
                  animation='border'
                  role='status'
                />
              )}
            </Button>
          </div>
        </div>
        <StatusAlerts state={this.state} />
      </Container>
    );
  }
}

export default withRouter(withTranslation()(ForgotPassword));
